import { showErrorToast } from "./toast"
import axios from "axios"
import { BACKEND_URL } from "../services/backendURL"

const handleError = (error, history) => {
    if (error.response && error.response.status === 403) {
        handleLogout(history)
    } else if (error.response && error.response.data && error.response.data.Error) {
        showErrorToast(error.response.data.Error)
    } else {
        showErrorToast("Pati një problem.")
    }
}

const handleLogout = (history) => {
    deleteToken()
    localStorage.clear()
    history.push('/login')
}

const deleteToken = () => {
    let a = localStorage.getItem("authUser")
    let authUser = JSON.parse(a)

    if (authUser) {
        const config = {
            headers: {
              'Authorization': "Token " + authUser.key,
            },
        }
    
        axios.defaults.headers.common['Authorization'] = ''

        axios
            .post(BACKEND_URL+'/api/rest-auth/logout/?format=json', {}, config)
            .then(response=>{})
            .catch(error=>{})
    }
}

export { handleError }

	
	
